import { __awaiter } from 'tslib';
import axios from 'axios';
import baseV3Service from './base/baseV3Service.js';

const getSignedURL = (uploadType, config) => {
    return baseV3Service.get(`uploads/${uploadType}/signed-url`, config);
};
const uploadFileToPreSignedURL = (url, file, onUploadProgress) => __awaiter(void 0, void 0, void 0, function* () {
    // The presigned url only signs `host`, so whatever content type we send is
    // what S3 stores. Restricting it to images left every other upload stored as
    // application/x-www-form-urlencoded.
    const headers = file.type ? { "Content-Type": file.type } : {};
    return axios(url, {
        method: "PUT",
        data: file,
        headers,
        onUploadProgress,
    })
        .then((response) => response.data)
        .catch((error) => {
        console.error("Error uploading file to pre-signed URL", error);
        throw error;
    });
});

export { getSignedURL, uploadFileToPreSignedURL };
